import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=ff2eb79e&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=ff2eb79e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2eb79e",
  null
  
)

export default component.exports